import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";

/**
 * Simple filter form used by "Акт сверки АВР PTC".
 * Props:
 * - q: current query string
 * - setQ: setter function for query
 * - onSubmit: submit handler (e) => { ... }
 * - onClear: clear/reset handler (e) => { ... }
 */
const AVR_STATUSES = [
    { id: 'AVR_NOT_SIGNED', name: 'Не подписан' },
    { id: 'AVR_READY_FOR_SIGN', name: 'Готов к подписанию' },
    { id: 'AVR_SIGNED_BY_DRIVER', name: 'Подписан водителем' },
    { id: 'AVR_SIGNING_IN_PROGRESS', name: 'Подписание в процессе' },
    { id: 'AVR_SIGNED', name: 'Подписан' },
    { id: 'AVR_SIGN_FAILED', name: 'Ошибка подписания' },
    { id: 'AVR_AUTO_SIGNED', name: 'Автоподписан' },
    { id: 'AVR_DEFERRED', name: 'Отложено' },
    { id: 'AVR_COMPLETED_AND_PAID', name: 'АВР подписан и средства перечислены на баланс' },
];

const AvrPtcFilter = ({ filterParam, setFilterParam, onSubmit, onClear }) => {

    return (
        <form onSubmit={onSubmit}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="user">Телефон/ФИО/БИН/Наименование ЮР лица</label>
                    <InputText
                        id="user"
                        name="q"
                        value={filterParam.q || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, q: e.target.value })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="avrNum">Номер АВР</label>
                    <InputText
                        id="avrNum"
                        name="avrNum"
                        value={filterParam.avrNum || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, avrNum: e.target.value })}/>
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="statusId">Статус АВР</label>
                    <Dropdown
                        id="status"
                        name="status"
                        value={ filterParam.status }
                        options={AVR_STATUSES}
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Статус АВР"
                        showClear
                        onChange={(e) => setFilterParam({ ...filterParam, status: e.value })}
                    />
                </div>
            </div>
                <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="startDate">Дата начала</label>
                    <Calendar id="startDate" value={filterParam.startDate}
                              name="startDate"
                              onChange={(e) => setFilterParam({ ...filterParam, startDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, startDate: null })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="endDate">Дата конца</label>
                    <Calendar id="endDate" value={filterParam.endDate}
                              name="endDate"
                              onChange={(e) => setFilterParam({ ...filterParam, endDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, endDate: null })}
                    />
                </div>
            </div>
            <div className="p-grid p-justify-end">
                <div className="p-mr-2">
                    <Button type="submit" label="Найти" />
                </div>
                <div className="p-mr-2">
                    <Button className="p-button-warning" label="Сбросить" onClick={onClear} />
                </div>
            </div>
        </form>
    );
};

AvrPtcFilter.propTypes = {
    filterParam: PropTypes.object.isRequired,
    setFilterParam: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default AvrPtcFilter;
